<template>
  <div class="row main content-block">
      <div class="container-fluid">
          <form class="row" v-show="!isLoading">
              <div class="cla-box well">
                  <div v-html="cla"></div>
              </div>
          </form>
          <div class="loading-indicator" v-show="isLoading">
              <img src="/static/images/link_inactive.svg" class="center-div spin-img ">
          </div>
      </div>
  </div>
</template>

<script>
import {getGuestCla} from '@/api/cla'
export default {
  data () {
    return {
      cla:'',
      isLoading:true
    };
  },
  created() {
    this._getGuestCla()
  },
  methods: {
    _getGuestCla() {
      getGuestCla().then((res) =>{
        this.cla = res.raw
        this.isLoading = false
      })
    }
  }
}

</script>
<style>
</style>


// WEBPACK FOOTER //
// src/javascript/home/components/template/guest.vue